import React from 'react';
import { useTheme } from '@mui/material/styles';
import { getSvgPath } from '@wheeebo/polaris-svg';
import { useColorMode } from '../../colorMode';
import Marker from './Marker';
const VehicleMarker = ({ selected, satellite, heading, muiIcon, scale, symbolAnchor, ...props }) => {
    const theme = useTheme();
    const colorMode = useColorMode();
    const color = selected
        ? theme.palette.warning.main
        : satellite
            ? '#00ffff'
            : colorMode.isThemeDark
                ? theme.palette.common.white
                : theme.palette.common.black;
    const path = React.useMemo(() => getSvgPath(muiIcon), [muiIcon]);
    return (React.createElement(Marker, { ...props, icon: {
            path,
            strokeColor: color,
            fillColor: color,
            fillOpacity: 1,
            scale,
            rotation: heading,
            anchor: symbolAnchor ?? new google.maps.Point(16 / scale, 16 / scale),
        } }));
};
export default React.memo(VehicleMarker);
